// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"6dfb2292","115":"7ceb49df","203":"ed082755","707":"7d3728de"}[chunkId] + ".chunk.js";
};